import React from 'react';
import { useLanguage } from '../../../features/language/useLanguage';

interface RoastFormNotesSectionProps {
  notes: string;
  onNotesChange: (value: string) => void;
  readOnly?: boolean;
}

export const RoastFormNotesSection: React.FC<RoastFormNotesSectionProps> = React.memo(({ notes, onNotesChange, readOnly = false }) => {
  const { t } = useLanguage();
  return (
    <div className="w-full">
      <label className="text-xs text-gray-600">{t('reports.details.notes')}</label>
      <textarea
        value={notes}
        onChange={event => onNotesChange(event.target.value)}
        disabled={readOnly}
        className={`w-full border rounded p-1.5 text-sm h-24 ${readOnly ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''}`}
        placeholder={t('roast.formNotes.enterNotes')}
      />
    </div>
  );
});
